/**
 * Shared helper utilities for driver operations.
 */

import { Driver } from '../services/api';

/**
 * Check if a driver has valid consent for licence checking.
 * Consent is valid if:
 * - consentProvided is true
 * - consentExpiry exists and is in the future
 */
export const hasValidConsent = (driver: Driver): boolean => {
    const now = new Date();
    return !!(
        driver.consentProvided &&
        driver.consentExpiry &&
        new Date(driver.consentExpiry) > now
    );
};

/**
 * Quick-filter controls are exclusive shortcuts. Clicking a different issue,
 * or one of several active issues, isolates that issue; clicking the only
 * active issue toggles the shortcut off. The full issue dropdown remains
 * responsible for intentional multi-select filtering.
 */
export const getExclusiveQuickIssueSelection = (
    currentIssues: string[],
    specialIssue: string | null,
    clickedIssue: string,
): string[] => {
    const activeIssues = new Set([
        ...currentIssues,
        ...(specialIssue ? [specialIssue] : []),
    ]);

    return activeIssues.size === 1 && activeIssues.has(clickedIssue)
        ? []
        : [clickedIssue];
};
